const $ = require('jquery');

const $body = $('body'),
    $megaMenu = $('.mega-menu'),
    $masthead = $('header[role="masthead"]'),
    classMegaMenuVisible = 'show-menu',
    classChildActive = 'menu__item--child-active',
    classMenuShifted = 'mega-menu--shifted';

if ($megaMenu.length > 0) {
    $megaMenu.each(function () {
        let $menu = $(this);

        $('a.menu__link', this).on('mouseenter', function () {
            if (viewport().width > 1024) {
                if ($(this).closest('.mega-menu__column--primary').length > 0) {
                    $menu.find('[data-menu-id]').hide().css('opacity', 0);
                    $menu.find('li.menu__item').removeClass(classChildActive);
                } else if ($(this).closest('.mega-menu__column--secondary').length > 0) {
                    $menu.find('.mega-menu__column--tertiary [data-menu-id]').hide().css('opacity', 0);
                    $menu.find('.mega-menu__column--secondary li.menu__item').removeClass(classChildActive);
                }

                let targetID = $(this).attr('data-target-id'),
                    target2ID = $(this).attr('data-target-2-id');

                if (typeof targetID !== 'undefined') {
                    let $target = $menu.find('[data-menu-id="'+targetID+'"]');

                    if ($target.length > 0) {
                        $(this).closest('.menu__item').addClass(classChildActive);

                        $target.show();
                        setTimeout(function () {
                            $target.css('opacity', 1);
                        }, 10);
                    }
                }

                // main items can have a second target ("placeholder" layer 3 blocks)
                if (typeof target2ID !== 'undefined') {
                    let $target2 = $menu.find('[data-menu-id="'+target2ID+'"]');

                    if ($target2.length > 0) {
                        $(this).closest('.menu__item').addClass(classChildActive);

                        $target2.show();
                        setTimeout(function () {
                            $target2.css('opacity', 1);
                        }, 10);
                    }
                }

                // if item layer 2 link in has no blocks, show placeholder blocks from layer 1 item (if it has any)
                if ($(this).closest('.mega-menu__nav--secondary').length > 0) {
                    if (typeof targetID === 'undefined' && typeof target2ID === 'undefined') {
                        let menuID = $(this).closest('.mega-menu__nav--secondary').attr('data-menu-id'),
                            $parentItem = $menu.find('.mega-menu__nav--primary a[data-target-id="' + menuID + '"]');

                        if ($parentItem.length > 0) {
                            let targetID = $parentItem.attr('data-target-2-id'),
                                $target = $menu.find('[data-menu-id="'+targetID+'"]');

                            if ($target.length > 0) {
                                $parentItem.addClass(classChildActive);

                                $target.show();
                                setTimeout(function () {
                                    $target.css('opacity', 1);
                                }, 10);
                            }
                        }
                    }
                }
            }
        });

        $('button.menu__link', this).on('click', function () {
            $menu.addClass(classMenuShifted);

            let targetID = $(this).attr('data-target-id');

            if (typeof targetID !== 'undefined') {
                let $target = $menu.find('[data-menu-id="'+targetID+'"]');

                if ($target.length > 0) {
                    $target.show();
                    setTimeout(function () {
                        $target.css('opacity', 1);
                    }, 10);
                }
            }
        });

        $('button.mega-menu__back', this).on('click', function () {
            $menu.removeClass(classMenuShifted);
            $menu.find('.mega-menu__column--secondary [data-menu-id]').hide().css('opacity', 0);
        });
    });

    $('[data-toggle="mega-menu"]').on('click', function () {
        if ($body.hasClass(classMegaMenuVisible)) {
            $megaMenu.closeMenu();
        } else {
            $megaMenu.openMenu();
        }
    });

    function setMegaMenuTopSpacing () {
        let spacing = $masthead.find('.top-bar').outerHeight();

        if ($body.hasClass('logged-in') && $body.hasClass('admin-bar')) {
            spacing = spacing + $('#wpadminbar').outerHeight();
        }

        $megaMenu.css('paddingTop', spacing);
    }

    setMegaMenuTopSpacing();
    $(window).on('resize', setMegaMenuTopSpacing);

    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            $megaMenu.closeMenu();
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.mega-menu').length > 0 && !$(e.target).closest('header[role="masthead"]').length > 0) {
            $megaMenu.closeMenu();
        }
    });

    $.fn.openMenu = function () {
        $body.addClass(classMegaMenuVisible);

        // trigger first item to appear active
        $('.mega-menu__column--primary a.menu__link', this).first().trigger('mouseenter');
    }

    $.fn.closeMenu = function () {
        $body.removeClass(classMegaMenuVisible);

        // reset all classes
        $(this).removeClass(classMenuShifted);
        $('li.menu__item', this).removeClass(classChildActive);
        $('.mega-menu__column--secondary [data-menu-id], .mega-menu__column--tertiary [data-menu-id]', this).hide().css('opacity', 0);
    }
}
